import { METHOD } from '../utils/Constant';
import { URL } from '../utils/Config';
import { getApiClient, getFullAuthHeaders } from './base';
export const createTask = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.POST,
    url: URL.CREATE_TASK,
    data,
  });
};
export const getTaskDetails = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.GET,
    url: URL.TASK_DETAILS,
    params,
  });
};
export const updateAssignTask = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.POST,
    url: URL.ASSIGN_TASK,
    data,
  });
};

export const updateTaskDetails = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.PATCH,
    url: URL.UPDATE_TASK_STATUS,
    data,
  });
};

export const getTaskList = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.POST,
    url: URL.TASK_LIST,
    data,
  });
};
